<template>
  <div class="container">
    <div class="handle-box">
      <el-input
        size="small"
        placeholder="文章标题"
        v-model.trim="title"
        class="handle-input mr10"
      ></el-input>
      <el-select size="small" v-model="status" @change="search" class="mr10">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-button
        size="small"
        type="primary"
        @click="$router.push('/operate/news/add')"
        >发布文章</el-button
      >
    </div>
    <el-table
      :data="data.records"
      border
      class="table"
      :row-style="rowStyle"
      ref="multipleTable"
      @row-click="rowClick"
    >
      <el-table-column width="180px" align="center" label="培训封面">
        <template #default="scope">
          <div
            class="cover"
            :style="`background-image:url(${$utils.fileUrl(scope.row.cover)})`"
          ></div>
        </template>
      </el-table-column>
      <el-table-column
        prop="title"
        header-align="center"
        label="活动标题"
      ></el-table-column>
      <el-table-column prop="viewCount" width="80" label="阅读" align="center">
      </el-table-column>
      <el-table-column label="上架状态" width="110px" align="center">
        <template #default="scope">
          <el-button
            type="success"
            size="mini"
            @click.stop="setData(scope.row, 1)"
            v-if="scope.row.status === 0"
            >设为公开</el-button
          >
          <el-button
            type="warning"
            size="mini"
            @click.stop="setData(scope.row, 0)"
            v-if="scope.row.status === 1"
            >下架文章</el-button
          >
        </template>
      </el-table-column>
      <el-table-column label="操作" width="220" align="center">
        <template #default="scope">
          <el-button type="primary" size="mini" @click.stop="edit(scope.row)"
            >编辑文章</el-button
          >
          <el-button type="danger" size="mini" @click.stop="del(scope.row.id)"
            >删除文章</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        background
        layout="total, prev, pager, next"
        :current-page="data.current"
        :page-size="20"
        :total="data.total"
        @current-change="getData"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {},
      title: "",
      status: "",
      loading: false,
      options: [
        { label: "全部", value: "" },
        { label: "下架", value: "0" },
        { label: "上架", value: "1" },
      ],
    };
  },
  created() {
    this.getData();
  },
  methods: {
    rowStyle() {
      return "cursor:pointer";
    },
    search() {
      this.getData();
    },
    async getData(page = 1) {
      if (this.title.length > 40) {
        this.$message.warning("搜索条件不能超过40个字");
        return;
      }
      try {
        const params = {
          title: this.title,
          status: this.status,
          currentPage: page,
          pageSize: 20,
        };
        this.$loading.start();
        const res = await this.$api.operate.news.getData(params);
        this.$loading.done();
        if (res.code === 10200) {
          this.data = res.data;
        } else {
          this.$message.error(res.msg);
        }
      } catch (error) {
        this.$loading.done();
      }
    },
    edit(data) {
      this.$store.dispatch("news/setData", data);
      this.$router.push(`/operate/news/edit`);
    },
    // 删除
    del(id) {
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.submitDel(id);
        })
        .catch(() => {});
    },
    // 提交删除
    async submitDel(id) {
      if (!this.loading) {
        try {
          this.loading = true;
          this.$loading.start();
          const res = await this.$api.operate.news.delData(id);
          this.loading = false;
          this.$loading.done();
          if (res.code === 10200) {
            this.$message.success("删除成功!");
            this.getData(this.data.current);
          } else {
            this.$message.error(res.msg);
          }
        } catch (error) {
          this.loading = false;
          this.$loading.done();
        }
      }
    },
    // 修改状态
    setData(data, status) {
      this.$confirm("是否修改状态?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const params = {
            id: data.id,
            status: status,
          };
          this.submitSetData(params);
        })
        .catch(() => {});
    },
    async submitSetData(params) {
      if (!this.loading) {
        try {
          this.loading = true;
          this.$loading.start();
          const res = await this.$api.operate.news.setData(params);
          this.loading = false;
          this.$loading.done();
          if (res.code === 10200) {
            this.$message.success("修改成功!");
            this.getData(this.data.current);
          } else {
            this.$message.error(res.msg);
          }
        } catch (error) {
          this.loading = false;
          this.$loading.done();
        }
      }
    },
    rowClick(row) {
      this.$store.dispatch("news/setData", row);
      let { href } = this.$router.resolve({ path: "/news/preview" });
      window.open(href, "_blank");
    },
  },
  watch: {
    status: {
      handler(val, ovl) {
        this.getData();
      },
    },
    title: {
      handler(val, ovl) {
        this.getData();
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.handle-box {
  margin-bottom: 20px;
  .handle-input {
    width: 200px;
    display: inline-block;
  }

  .el-select {
    width: 120px;
  }
}

.cover {
  width: 160px;
  height: 90px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
</style>